const CONFLICT_STATUS = 409;

/** Checks whether an error from the events registration API represents
 * a duplicate-registration conflict (HTTP 409) */
export function isConflictError(error) {
  const classification = error?.classification ?? error?.meta?.classification;
  return classification?.startsWith('EVENTS_ALREADY_REGISTERED') || error?.status === CONFLICT_STATUS;
}
